import constsBreakpoints from '@common/utils/consts.breakpoints';

export const breakpoints = {};

breakpoints.install = function (Vue) {
  Vue.prototype.$breakpoints = (function () {
    return {...constsBreakpoints};
  })();
};
